import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';

const ContactoPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ContactHero />
        <ContactForm />
        <ContactMap />
      </main>
      <Footer />
    </div>
  );
};

export default ContactoPage;
